const faqs = [
  {
    question: "What areas does ContainX deliver to?",
    answer: "We generally deliver within about a 50-mile radius of our Elkridge, Maryland warehouse. Our scheduled routes serve the greater DMV area, including locations as far as Chantilly and Woodbridge, Virginia, and Frederick and Bel Air, Maryland. Route availability depends on your location, order size, and schedule.",
  },
  {
    question: "How far in advance should I place an order?",
    answer: "Call or text your order at least 24–48 hours in advance for weekday delivery. If you are farther from our warehouse or outside a regular route, please order earlier so we have time to add your stop to that week’s delivery schedule.",
  },
  {
    question: "Can I pick up my order?",
    answer: "Yes. Pickup is available from our Elkridge warehouse during normal business hours. Scheduled delivery is also available during business hours. Please contact us before pickup so we can confirm availability and have your order ready.",
  },
  {
    question: "Is there a minimum order for delivery?",
    answer: "Delivery minimums vary based on your location and our route schedule. Contact us with your delivery address and the products you need, and we’ll confirm the applicable minimum before you place the order.",
  },
  {
    question: "Do you provide samples, and are catalog products in stock?",
    answer: "Free product samples are available in our showroom. We do our best to keep the products in our catalog in stock, but availability can change. Call or text before visiting or ordering so we can confirm inventory and prepare the right samples.",
  },
  {
    question: "What payment methods do you accept?",
    answer: "We accept most common forms of payment. Retail customers can pay with cash, tap-to-pay, or credit card. Business customers can pay by cash, ACH, Zelle, or business check. Contact us if you need to confirm a payment method before ordering.",
  },
];

const FaqSection = () => (
  <section id="faq" className="bg-slate-50 px-6 py-14 md:py-20">
    <div className="mx-auto max-w-4xl">
      <div className="text-center">
        <p className="mb-2 text-sm font-bold uppercase tracking-widest text-containx-tan">Helpful information</p>
        <h2 className="text-3xl font-bold text-containx-navy md:text-4xl">Frequently Asked Questions</h2>
        <p className="mx-auto mt-4 max-w-2xl leading-7 text-slate-600">Ordering, delivery, pickup, samples, and payment information for ContainX customers.</p>
      </div>
      <div className="mt-10 space-y-4">
        {faqs.map((faq) => (
          <details key={faq.question} className="group rounded-xl bg-white shadow-sm ring-1 ring-black/5">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 px-5 py-5 font-semibold text-containx-navy sm:px-6">
              <span>{faq.question}</span>
              <span aria-hidden="true" className="text-2xl leading-none text-containx-tan transition group-open:rotate-45">+</span>
            </summary>
            <p className="border-t border-slate-100 px-5 py-5 leading-7 text-slate-600 sm:px-6">{faq.answer}</p>
          </details>
        ))}
      </div>
    </div>
  </section>
);

export default FaqSection;
